import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Events } from 'ionic-angular';
import { HttpClient } from '../../../services/HttpClient';

import { AddGroupPage } from './addGroup/addGroup';
import { GroupPage } from './group/group';

@Component({
  selector: 'page-groups',
  templateUrl: 'groups.html',
  providers : [HttpClient]
})
export class GroupsPage {

	groups;
  searchQuery = '';

  modalCtrl : ModalController;
	
  httpClient : HttpClient;

  events : Events;

  	constructor(public navCtrl: NavController, public navParams: NavParams, httpClient : HttpClient,modalCtrl : ModalController, events : Events) {
  		this.modalCtrl = modalCtrl;
      this.httpClient = httpClient;
      this.events = events;
      this.events.subscribe('addGroup:done',()=>{
        this.httpCallGroups('',1000);
      });
      this.events.subscribe('group:delete',()=>{
        this.httpCallGroups('',1000);
      });
      this.events.subscribe('group:update',()=>{
        this.httpCallGroups('',1000);
      });
      this.httpCallGroups('',1000);
  	}

    onSearch(){
      if(this.searchQuery.length > 0){
        this.httpCallGroups(this.searchQuery,50);
      }else{
        this.httpCallGroups(this.searchQuery,1000);
      }
    }

    httpCallGroups(name,max){
      this.httpClient.get('/groups?name='+name+'&max='+max,(error,data)=>{
       if(data) this.groups = data.json();
      });
    }

    onClickAdd(){
      this.navCtrl.push(AddGroupPage);
    }

    onClickGroup(group){
      this.navCtrl.push(GroupPage,{id : group.id});
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/groups/groups.ts